module.exports = __webpack_public_path__ + "img/operational_monitoring_de.336d82a8.svg";